// utils
function getUrlQueries() {
  var queryStr = window.location.search.slice(1);  // 文頭?を除外
  var queries = {};

  // クエリがない場合は空のオブジェクトを返す
  if (!queryStr) return queries;

  // クエリ文字列を & で分割してqueriesに格納
  queryStr.split('&').forEach(function(queryStr) {
    var queryArr = queryStr.split('=');
    queries[queryArr[0]] = queryArr[1];
  });

  return queries;
}

// headerのドロップダウン背景制御
document.addEventListener('DOMContentLoaded', () => {
  var elHeaderDropdownBg = document.querySelector('.js-header-dropdown-bg');
  var elNavWidhDropdown = document.querySelectorAll('.js-nav-with-dropdown');

  elNavWidhDropdown.forEach((el) => {
    el.addEventListener('mouseover', () => {
      elHeaderDropdownBg.style.display = 'block';
    });
    el.addEventListener('mouseout', () => {
      elHeaderDropdownBg.style.display = 'none';
    });
  })
});